import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ReferralInfoComponent } from '../../features/referral-pages/referral-info/referral-info.component';
import { CivilCaseReferralPageComponent } from 'src/app/features/referral-pages/civil-case-referral-page/civil-case-referral-page.component';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class ReferralInfoDeactivateGuard implements CanDeactivate<ReferralInfoComponent> {

    private title = inject(Title);
    
    canDeactivate(component: ReferralInfoComponent): Promise<boolean> {
        this.title.setTitle('External Agency Portal')
        return component.checkDataChangeOnExit();
    }
}

@Injectable({ providedIn: 'root' })
export class CivilReferralInfoDeactivateGuard implements CanDeactivate<CivilCaseReferralPageComponent> {

    private title = inject(Title);

    canDeactivate(component: CivilCaseReferralPageComponent): Promise<boolean> {
        this.title.setTitle('External Agency Portal')
        return component.checkDataChangeOnExit();
    }
}
